export const SDK_NAME = 'sentry.javascript.capacitor';
export const SDK_VERSION = '0.4.0';
